import { Fragment } from 'react';
import { useRoutes } from 'react-router-dom';
import router, { filterRouter } from 'src/router';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { SnackbarProvider } from 'notistack';
import useAuth from 'src/hooks/useAuth';

import { CssBaseline } from '@mui/material';
import 'leaflet/dist/leaflet.css';
import { ConfirmProvider } from 'material-ui-confirm';
import { Toaster } from 'react-hot-toast';
import StatusMaintenance from 'src/content/pages/Status/Maintenance';
import VersionChecker from 'src/components/VersionChecker';

import AppInit from './components/AppInit';
import './styles/custom.style.css';
import ThemeProvider from './theme/ThemeProvider';

function App() {
  const auth = useAuth();
  const maintenanceMode = localStorage.getItem('maintenanceMode');

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ConfirmProvider>
          <SnackbarProvider
            maxSnack={6}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
          >
            <CssBaseline />
            <VersionChecker />
            {maintenanceMode ? (
              <StatusMaintenance />
            ) : auth.isInitialized ? (
              <Fragment key={+auth.isAuthenticated + +auth.isInitialized}>
                {useRoutes(
                  filterRouter(router, (id) => {
                    return (
                      auth.user?.role === 'SUPER_ADMIN' ||
                      auth.permissions?.some((p) => {
                        if (id.includes('*')) {
                          return p.startsWith(id.replace('*', ''));
                        }
                        return p === id;
                      })
                    );
                  })
                )}
              </Fragment>
            ) : (
              <AppInit />
            )}
          </SnackbarProvider>
          <Toaster position="top-center" reverseOrder={false} />
        </ConfirmProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
